// Lecturas públicas del negocio sin tocar la tabla `businesses` (que guarda tokens y correos): van por funciones de la base
// (20261008a_businesses_public_functions.sql) que solo devuelven columnas públicas.

// Minisitio de reservas: negocio + servicios + equipo público, o null si el slug no existe.
export async function fetchPublicBusiness(client, slug) {
  const { data, error } = await client.rpc('public_booking_business', { p_slug: slug });
  if (error) throw error;
  return data && typeof data === 'object' ? data : null;
}

// Login: antes de tener sesión solo se necesita saber si el correo es de un negocio, su id, nombre y si está activo.
export async function lookupBusinessForLogin(client, email) {
  const { data, error } = await client.rpc('business_login_lookup', { p_email: email });
  if (error) {
    console.warn('No se pudo buscar el negocio por correo:', error.message);
    return null;
  }
  return data && typeof data === 'object' ? data : null;
}
